// levant.ts
// CONTRACT:P1-CANONICAL-ENVELOPE.1.0
//
// COP — the WIRED multi-INT "Levant" theater. A thin wrapper that binds
// ./scenario-levant.json to the generic theater loader (./theaters.ts), mirroring
// hormuz.ts's public surface (startLevantScenario / levantEnvelopes). Every record
// carries REAL corpus markings and is published as a CanonicalEnvelope onto the
// SAME bus → LOCAL PDP (I4) → render path, so the clearance filter bites on the
// WHOLE picture (permit → show / deny → absent).

import type { EnvelopeBus } from "../host/envelopeBus.ts";
import type { CanonicalEnvelope } from "../../../../packages/schema/ts/envelope.ts";
import {
  startTheaterScenario,
  theaterEnvelopes,
  type TheaterDef,
  type TheaterHandle,
  type TheaterRecord,
} from "./theaters.ts";
import levantData from "./scenario-levant.json";

/** The Levant theater definition (the corpus + its stamped metadata). */
export const LEVANT_THEATER: TheaterDef = {
  id: "levant",
  label: "Levant",
  records: levantData as unknown as TheaterRecord[],
};

export interface LevantHandle extends TheaterHandle {}

/** Project the Levant corpus to envelopes once (static snapshot / tests). */
export function levantEnvelopes(): CanonicalEnvelope[] {
  return theaterEnvelopes(LEVANT_THEATER);
}

/** Start the live Levant picture (emit-once + per-tick re-emit). */
export function startLevantScenario(bus: EnvelopeBus, tickMs = 1_000): LevantHandle {
  return startTheaterScenario(LEVANT_THEATER, bus, tickMs);
}
